import { render } from "./CoachReport.vue?vue&type=template&id=d9ee321c"
import script from "./CoachReport.vue?vue&type=script&lang=js"
export * from "./CoachReport.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__